import Review from '../Review/Review';

const AddServices = () => {

    return (
        <div className='container'>
            <Review></Review>
        </div>
    );
};

export default AddServices;